module.exports = __webpack_public_path__ + "img/v3ntures.3d505d3d.png";